module.exports = {
	"pagination": {
		"DescribeScalableTargets": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ScalableTargets"
		},
		"DescribeScalingActivities": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ScalingActivities"
		},
		"DescribeScalingPolicies": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ScalingPolicies"
		},
		"DescribeScheduledActions": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ScheduledActions"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/application-autoscaling-2016-02-06.paginators.json
// module id = 1878
// module chunks = 0